import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class JobAssignmentGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var assignmentGrid = this;
		setTimeout(function(){
			assignmentGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var assignmentGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'vaadin-combo-box',
					label: 'Filter Field',
					itemid: 'filterField',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,
					value: 'jobName',
					postinit: function (combo) {
						combo.items = [
							{
								code: 'jobName',
								description: 'Job Name'
							},
							{
								code: 'jobGroupName',
								description: 'Group Name'
							},
							{
								code: 'assignedNodeId',
								description: 'Node Id'
							}
						];						
					}
				},				
				{
					tag: 'vaadin-text-field',
					itemid: 'filterValue',
					'class': 'spacer-toolbar-item',
					'keep-open': true,
					label: 'Filter By',
					listeners: {
						input: {
							fn: function() {
								actionRefresh();
							},
							buffer: 2000
					    }
					}
				},																			
				{
					tag: 'dl-action-button',
					itemid: 'deleteBtn',
					theme: 'error primary',
					'class': 'spacer-toolbar-item',
					style: 'margin-top: 18px; float: right;',
					permissions: ['ADMIN_JOB_MANAGEMENT:DELETE'],
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Delete')						
					],
					properties: {
						menu: [
							{
								tag: 'vaadin-item',
								itemid: 'delete',
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:trash"></vaadin-icon> Delete',
								disabled: true,
								listeners: {
									click: function(event) {
										actionDelete(grid.selectedItems[0]);
									}
								}
							},
							{
								tag: 'hr'
							},
							{
								tag: 'vaadin-item',
								itemid: 'deleteAll',
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:close"></vaadin-icon> Delete All',
								listeners: {
									click: function(event) {
										actionDeleteAll(grid.selectedItems[0]);
									}
								}
							}
						]
					}					
				}
			]
		});		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [
				{						
					path: 'assignedNodeId',
					header: 'Assigned Node Id',
					width: '7em'
				},	
				{						
					path: 'jobName',
					header: 'Job Name',
					width: '7em'
				},
				{						
					path: 'jobGroupName',
					header: 'Group Name',
					'text-align': 'center',
					width: '7em'
				},	
				{						
					path: 'jobClassName',
					header: 'Class Name',
					width: '7em',
					'text-align': 'center'
				},
				{						
					path: 'runStatus',
					header: 'Status',
					resizable: true,
					width: '7em'
				},
				{						
					path: 'priority',
					header: 'Priority',					
					width: '7em'
				},
				{						
					path: 'submitedDts',
					header: 'Submit Date',					
					width: '7em',
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.submitedDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},
				{						
					path: 'startDts',
					header: 'Start Date',					
					width: '7em',
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.startDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					
					var deleteBtn = ElementUtil.query(toolbar, 'deleteBtn');
					var deleteMenu = ElementUtil.query(deleteBtn, 'delete');
					if (grid.selectedItems.length > 0) {
						if (deleteMenu){
							deleteMenu.disabled = false; 									
						}
					} else {	
						if (deleteMenu){
							deleteMenu.disabled = true;
						}
					}
				}
			}
		});			
	
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					assignmentGrid.currentFilter = {
						offset: pageRange.offset,
						max: pageRange.max,
						sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'jobName',
						sortOrder: backingGrid.currentSortDirection ? backingGrid.currentSortDirection : 'ASC',
						filterField: ElementUtil.query(toolbar, 'filterField').value,
						filterValue: ElementUtil.query(toolbar, 'filterValue').value
					};						
					
					var successHandler = function(records) {
						loadMask.remove();
						grid.activeItem = null;						
						grid.items = records.data;
															
						pagingToolbar.totalRecords = records.totalNumber;
						pagingToolbar.updatePager();						
					};
					
					Service.getJobService().getJobAssignments(assignmentGrid.currentFilter)
							.then(function(records){							
						successHandler(records);
					});										
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();					
				}
			}
			
		});			
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				pagingToolbar
			]
		});		
		assignmentGrid.append(flexLayout);		
				
		
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);	
		};	
		
		var actionDelete = function(record) {
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to <b>Delete</b> the selected assignment?<br>Working jobs are not cancel; just Assignment is removed.',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Deleting Assignment...');

							Service.getJobService().deleteJobAssignment(record.assignmentId)
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Deleted Assignment', {									
									theme: 'success'
								});
								actionRefresh();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});
		};

		var actionDeleteAll = function() {
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete All',
				message: 'Are you sure you want to <b>Delete</b> the ALL assignments?<br>Working jobs are not cancel; just Assignment is removed.',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Deleting Assignment...');

							Service.getJobService().deleteALLJobAssignment()
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Deleted ALL Assignment', {									
									theme: 'success'
								});
								actionRefresh();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});
		};
		
	}
	
}
customElements.define('dl-jobassignment-grid', JobAssignmentGrid);

